import { get } from 'vio-libs';
export function getIXOverlays(consumerAPI = false) {
    if (!consumerAPI) {
        return get('internet-exchanges');
    }
    return get('v1/ix-locations', undefined, true);
}
